














import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class H5Menu extends Vue {
  navList: any = [
    {
      title: '首页',
      router: '/HomePage/Main'
    },
    {
      title: '课程培训',
      router: '/HomePage/TrainingCourse'
    },
    {
      title: '企业文化',
      router: '/HomePage/H5Culture'
    },
    {
      title: '共享交流',
      router: '/Share'
    },
    {
      title: '分蛋看点',
      router: '/HomePage/HotspotList'
    },
    {
      title: '个人中心',
      router: '/PersonalCenter'
    }
  ]

  mounted() {
    const vm = this

    // 监听点击事件，隐藏侧边导航
    window.addEventListener('click', function(e) {
      const isParent = vm._isParent(e.target, vm.$refs.nav)
      if (!isParent) {
        const nav = (vm.$refs as any).nav
        if (nav) nav.style.webkitTransform = `translate(30vw, 0)`
      }
    })
  }

  /**
   * 显示侧边导航
   */
  openNav(e: any): void {
    e.preventDefault()
    ;(this.$refs as any).nav.style.webkitTransform = `translate(0, 0)`
  }

  routerTo(router: string): void {
    this.$router.push(router)
  }

  /**
   * 判断当前元素是否某个元素的子元素
   */
  _isParent(obj: any, parentObj: any): boolean {
    while (obj != undefined && obj != null && obj.tagName.toUpperCase() != 'BODY') {
      if (obj == parentObj) {
        return true
      }
      obj = obj.parentNode
    }
    return false
  }
}
